import { IconChevronRight12 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IChipProps {
  children?: React.ReactNode;
  hasChevron?: boolean;
  asButton?: boolean;
  testId?: string;
  onClick?(): void;
}

export const Chip = ({ children, hasChevron = true, onClick, asButton = true, testId }: IChipProps) => {
  if (asButton) {
    return (
      <button className={styles['chip']} onClick={onClick} data-testid={testId}>
        {children}
        {hasChevron && (
          <span className={styles['icon']}>
            <IconChevronRight12 color="primary_100" />
          </span>
        )}
      </button>
    );
  }

  return (
    <div className={cn(styles['chip'], styles['chip_button'])} onClick={onClick} data-testid={testId}>
      {children}
      {hasChevron && (
        <span className={styles['icon']}>
          <IconChevronRight12 color="primary_100" />
        </span>
      )}
    </div>
  );
};
